import { useQuery } from 'react-query';

import { getLanguages as queryFn } from 'api/endPoints/getLanguages';

export const useQueryGetLanguageList = () => {
    return useQuery<ISelectOption<string>[], QueryError>({
        queryKey: 'languageList',
        queryFn: () => queryFn(),
    });
};
